export default {
	data() {
		return {
			qboSalesTaxes: [],
			qboTaxRate: null,
			expensePaymentTypeOptions: [
				{value: 'Business Card',text: 'Business Card'},
				{value: 'Business Cash',text: 'Business Cash'},
				{value: 'Personal Card/Cash',text: 'Personal Card/Cash'}
			],
		}
	},
	computed: {
		qboSalesTaxOptions() {
			return this.qboSalesTaxes.map(code => {
				let text = code.Name 
				if (code.Description)
					text += " ("+code.Description+")"

				return {
					value: code.Id,
					text
				}
			})
		},
		expenseTotal() {
			let total = 0

			if (this.qboIsActive) {
				let taxMultiple = 1 + (this.qboTaxRate/100)

				total = +this.expense.cost * taxMultiple
			}
			else {
				if ("cost" in this.expense && this.expense.cost)
					total += +this.expense.cost

				if ("tax" in this.expense && this.expense.tax)
					total += +this.expense.tax

				if ("tip" in this.expense && this.expense.tip)
					total += +this.expense.tip
			}

			if (isNaN(total))
				return "0.00"

			return total.toFixed(2)
		}
	},
	methods: {
		calcExpenseTotal(expense) {
			let total = 0

			if (this.qboIsActive) {
				let taxMultiple = 1 + (this.qboTaxRate/100)

				total = +expense.cost * taxMultiple

				if ("tip" in expense && expense.tip)
					total += +expense.tip
			}
			else {
				if ("cost" in expense && expense.cost)
					total += +expense.cost

				if ("tax" in expense && expense.tax)
					total += +expense.tax

				if ("tip" in expense && expense.tip)
					total += +expense.tip
			}

			if (isNaN(total))
				return "0.00"

			return total.toFixed(2)
		},
		paymentTypeChange(value) {
			let vm = this
			if (this.qboIsActive && value == 'Business Card') {
				this.fetchQBOCreditCards()
				if (!this.$store.qboUserCreditCardSettings || this.$store.qboUserCreditCardSettings.length == 0)
					this.fetchQBOCreditCardAccountsUserSettings()
			}
		},
		fetchQboSalesTaxes() {
			let vm = this
			return new Promise((resolve,reject) => {
				vm.fetchQboTaxCodes().then(response => {
					if (response.success) 
						vm.qboSalesTaxes = response.data

					resolve(response)
				})
			})
		},
		fetchQBOCreditCards() {
			let vm = this

			return new Promise((resolve,reject) => {
				vm.fetchQBOResource("Account","AccountType='Credit Card'",false).then(response => {
					if (response.success)
						vm.$store.qboCreditCardAccounts = response.data

					resolve(response)
				})
			})
		},
		getQboTaxRate(qboTaxCodeId) {
			let vm = this

			let taxCode = this.qboSalesTaxes.find(tax => tax.Id == qboTaxCodeId)

			return new Promise((resolve,reject) => {
				if (taxCode && "SalesTaxRateList" in taxCode && taxCode.SalesTaxRateList && "TaxRateDetail" in taxCode.SalesTaxRateList && taxCode.SalesTaxRateList.TaxRateDetail) {
					
					let promises = []
					if (Array.isArray(taxCode.SalesTaxRateList.TaxRateDetail)) {

						taxCode.SalesTaxRateList.TaxRateDetail.forEach(ref => {
							let where = "Id='"+ref.TaxRateRef+"'"
							promises.push(vm.getJSON("QuickbooksConnection/get-resource",{resource: "TaxRate",where}))
						})

					}
					else {
						let where = "Id='"+taxCode.SalesTaxRateList.TaxRateDetail.TaxRateRef+"'"
						promises.push(vm.getJSON("QuickbooksConnection/get-resource",{resource: "TaxRate",where}))

					}

					Promise.all(promises).then(responses => {

						let totalTaxRate = 0

						responses.forEach(response => {
							if (response.success && response.data.length > 0)
								totalTaxRate += +response.data[0].RateValue
						})

						vm.qboTaxRate = totalTaxRate

						resolve(vm.qboTaxRate)
					})
				}
				else
					resolve(vm.qboTaxRate)
			})
		},
	}
}